import axios from 'axios'
import Config from '../../config'
import authHeader from '@/services/auth-header'
import UserService from '@/services/user.service'
import Vue from 'vue'

if (localStorage.getItem('gpsServers')) {
  Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
} else {
  Vue.prototype.$gpsServers = Config.gpsServers
}
if (localStorage.getItem('apiServers')) {
  Vue.prototype.$apiServers = JSON.parse(localStorage.getItem('apiServers'))
} else {
  Vue.prototype.$apiServers = Config.apiServers
}

const API_URL = `${Vue.prototype.$apiServers.url}`


//const API_URL = `${Config.apiServers.url}`


export class AuthService {
  // eslint-disable-next-line class-methods-use-this
  login(user) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/login2`, {
        mobile: user.mobile,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
        },
      })
    // eslint-disable-next-line consistent-return
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  loginVerify(verifyLogin, payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/login/mobile-verify`, {
        mobile: payload.mobile,
        code: payload.code,
      })
      .then(response => {
        if (response.data.status === 'success') {
          if (response.data.result.numDevice !== 0) {
            localStorage.setItem('user', JSON.stringify(response.data.result))
          } else {
            localStorage.setItem('user_first', JSON.stringify(response.data.result))
          }
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  logout() {
    if (typeof Vue.prototype.$socket !== 'undefined') {
      // this.$socket.emit('devicesOnlineTime', {})
      Vue.prototype.$socket.emit('forceDisconnect')
      Vue.prototype.$socket.connect(false)
      Vue.prototype.$socket.disconnect(true)
      //Vue.prototype.$socket = null
    }
    localStorage.removeItem('user')
    UserService.updateFirebaseDataIfNeeded({ force: true, enable: false })
    window.location.reload(true)
  }

  // eslint-disable-next-line class-methods-use-this
  register(user) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/register`, {
        name: user.name,
        family: user.family,
        mobile: user.mobile,
      }, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'application/json',
        },
      })
      // eslint-disable-next-line consistent-return
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  loginPassword(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/login-password`, {
        mobile: payload.mobile,
        password: payload.password,
      })
      .then(response => {
        if (response.data.status === 'success') {
          if (response.data.result.numDevice !== 0) {
            localStorage.setItem('user', JSON.stringify(response.data.result))
          } else {
            localStorage.setItem('user_first', JSON.stringify(response.data.result))
          }
        }
        return response.data
      })
  }

  // eslint-disable-next-line class-methods-use-this
  resetPasswordRequest(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/reset-password/request`, {
        mobile: payload.mobile,
      })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  resetPasswordVerify(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/reset-password/verify`, {
        mobile: payload.mobile,
        code: payload.code,
      })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  resetPasswordSet(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/reset-password/set`, {
        mobile: payload.mobile,
        resetToken: payload.resetToken,
        password: payload.password,
      })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  setPassword(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/user/set-password`, {
        password: payload.password,
      }, {
        headers: authHeader(),
      })
      .then(response => response.data)
  }

  // eslint-disable-next-line class-methods-use-this
  registerVerify(payload) {
    return axios
      .post(`${Vue.prototype.$apiServers.url}/auth/register/mobile-verify2`, {
        name: payload.name,
        family: payload.family,
        mobile: payload.mobile,
        code: payload.code,
      })
      .then(response => {
        if (response.data.status === 'success') {
         // localStorage.setItem('user', JSON.stringify(response.data.result))
          localStorage.setItem('user_first', JSON.stringify(response.data.result))
        }
        return response.data
      })
  }
}

export default new AuthService()
